import markItemsAsReadBasedOnItemIds from './markItemsAsReadBasedOnItemIds';
import { ClientItemId } from 'owa-client-ids';
import { MailRowDataPropertyGetter, TableView } from 'owa-mail-list-store';
import { getAncestorsOfMessageIncludingCurrentItem } from 'owa-mail-store-unstacked/lib/utils/conversationRelationMapUtils';

// Marks the items in fork as read.
// When called from autoMarkReadTimer, rowKey is undefined and obtained from tableView and itemId is that of the actual item on reading pane.
// When called from onSingleSelectionChanged, rowKey is passed as a parameter because it might not be available in tableView
// for a scenario like folder change. itemId is the conversation id string for the selected row.
export default async function markItemsInForkAsRead(
    tableView: TableView,
    itemId: string,
    rowKey: string
) {
    if (!itemId) {
        return;
    }

    const rowKeyToActOn = rowKey || [...tableView.selectedRowKeys.keys()][0];
    const conversationId: ClientItemId = MailRowDataPropertyGetter.getRowClientItemId(
        rowKeyToActOn,
        tableView
    );
    const conversationIdString = conversationId?.Id;
    if (!conversationIdString) {
        // This happens when switching from drafts to other folder since drafts folder is treated as MessageView.
        // Mark as read behavior for unstacked reading pane no longer applies in this case and is handled like normal message view.
        return;
    }
    getAncestorsOfMessageIncludingCurrentItem(
        tableView.tableQuery.folderId,
        conversationIdString,
        itemId
    ).then((itemIdsToMark: string[]) => {
        markItemsAsReadBasedOnItemIds(
            tableView,
            itemIdsToMark,
            true /* isReadValueToSet */,
            false /* isExplicit */,
            null /* actionSource */,
            [] /* instrumentationContexts */
        );
    });
}
